<form #form="ngForm" autocomplete="off">
    <div class="ui segment">
        <app-segment-header
            title="{{ 'forms.applicant-tracker.basicInformation' | appTranslate }}"
        ></app-segment-header>

        <div class="app-grid">
            <mat-form-field class="columns-4 small-columns-12">
                <mat-label>{{ 'applicant-tracker.jobTitle' | appTranslate }}</mat-label>
                <input
                    type="text"
                    name="jobTitle"
                    #jobTitle="ngModel"
                    required
                    placeholder="{{ 'forms.applicant-tracker.webDeveloper' | appTranslate }}"
                    matInput
                    [(ngModel)]="jobPosting.title"
                />
                <mat-error *ngIf="jobTitle.invalid">{{ jobTitle.errors | formErrors }}</mat-error>
            </mat-form-field>
        </div>

        <div class="app-grid">
            <mat-form-field class="columns-4 small-columns-12">
                <mat-label appRemoveAriaOwns>{{ 'forms.applicant-tracker.jobType' | appTranslate }}</mat-label>
                <mat-select
                    name="jobLevel"
                    placeholder="{{ 'forms.applicant-tracker.selectAnOption' | appTranslate }}"
                    #level="ngModel"
                    [(ngModel)]="jobPosting.level"
                    required
                >
                    <mat-option value="full-time">{{
                        'full-time' | appTranslateOptions: employmentTypesDisplay | capitalize
                    }}</mat-option>
                    <mat-option value="part-time">{{
                        'part-time' | appTranslateOptions: employmentTypesDisplay | capitalize
                    }}</mat-option>
                    <mat-option value="contract">{{
                        'contract' | appTranslateOptions: employmentTypesDisplay | capitalize
                    }}</mat-option>
                    <mat-option value="internship">{{
                        'internship' | appTranslateOptions: employmentTypesDisplay | capitalize
                    }}</mat-option>
                    <mat-option value="volunteer">{{
                        'volunteer' | appTranslateOptions: employmentTypesDisplay | capitalize
                    }}</mat-option>
                </mat-select>
                <mat-error *ngIf="level.invalid">{{ level.errors | formErrors }}</mat-error>
            </mat-form-field>
        </div>

        <div class="app-grid">
            <mat-form-field class="columns-4 small-columns-12">
                <mat-label>{{ 'forms.applicant-tracker.category' | appTranslate }}</mat-label>
                <input
                    type="text"
                    placeholder="{{ 'forms.applicant-tracker.sales' | appTranslate }}"
                    pattern="[a-zA-Z0-9\u00C0-\u00FF\s]+"
                    matInput
                    required
                    #category="ngModel"
                    name="category"
                    [(ngModel)]="jobPosting.category"
                />
                <mat-error *ngIf="category.invalid">{{ category.errors | formErrors }}</mat-error>
            </mat-form-field>
        </div>
    </div>

    <app-manage-hiring-team
        (selectionUpdated)="updateHiringTeamAssign($event)"
        [employees]="jobPosting.hiringTeamAssign"
        [jobPostingCreationMode]="true"
    ></app-manage-hiring-team>
</form>
